module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/homePurchase.svg?393aa2e7da35c6cd5e4885c52fc65c90";